// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4264ebec","551":"23f52663"}[chunkId] + ".chunk.js";
};